import { Stack, SearchBox, Label, Spinner } from '@fluentui/react';
import { useState } from 'react';
import { useStore } from '../../../../../store/useStore';
import { useDebouncedEventHandler } from '@pum-spark/react-hooks';
import { useSearchUsers } from '../hooks/useSearchUsers';

export const SearchFilter = () => {
    const [currentSearchText, setCurrentSearchText] = useState<string>('');
    const handleSearchInput = useDebouncedEventHandler(
        (event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
            useStore.getState().setSearchText(newValue);
        },
        (e, v) => {
            setCurrentSearchText(v);
        },
    );

    const { isFetching } = useSearchUsers();

    return (
        <Stack horizontal styles={{ root: { width: '100%', margin: '0 auto' } }} tokens={{ childrenGap: 20 }}>
            <Stack>
                <Label htmlFor="search-users">Search Users</Label>
                <SearchBox
                    id="search-users"
                    placeholder="Search on Name, E-Mail, User Principal Name or User Number. Use minimum 3 characters"
                    onChange={handleSearchInput}
                    style={{ width: 600 }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            useStore.getState().setSearchText(currentSearchText);
                        }
                    }}
                />
            </Stack>
            <Stack horizontal verticalAlign="end" horizontalAlign="start">
                {isFetching && <Spinner />}
            </Stack>
        </Stack>
    );
};
